// extracted by mini-css-extract-plugin
export var currentPage = "Breadcrumbs-module--currentPage--0441d";
export var home = "Breadcrumbs-module--home--2ca7a";
export var link = "Breadcrumbs-module--link--cf777";
export var nav = "Breadcrumbs-module--nav--96f37";
export var segment = "Breadcrumbs-module--segment--7f0c5";